import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-au-grey-des-couleurs.webp");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-head-spa.jpg");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-villejuif.webp");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/ville-d-avray.webp");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedArticles"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/sections/RelatedArticles.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/link.js");
